export class BaseResultDTO {
  count?: number;
}

